import { memo, useEffect } from "react";

import { useFeatureIslandCategoryContext } from "@/components/features/_layouts/island/main-with-category/context";

import { Dot } from "@/components/ui/dot";
import { Label } from "@/components/ui/label/label";

import { QuestionItemsInnerWrapper } from "../../../../../items/edit/_shared/ui/components/system/question/_layouts/items-inner-wrapper";
import { EditGuideTooltip } from "../../../../../items/edit/_shared/ui/components/system/tooltip/edit-guide-tooltip";

export interface QuestionProps {
	required: boolean;
	title: string;

	inputChildren: React.ReactNode;

	isEdited: boolean | undefined;
	hasError: boolean | undefined;

	guide?: string;
}

const QuestionTitle = memo(({ title }: { title: string }) => {
	return <h5 className="mb-0.5 text-[17px] font-semibold leading-[24px]">{title}</h5>;
});

export const FeatureIslandCategoryQuestionForMain = memo(
	({
		title, //
		required,
		inputChildren,
		guide,
		isEdited = false,
		hasError = false,
	}: QuestionProps) => {
		const categoryTitle = useFeatureIslandCategoryContext((state) => state.title);

		const addErrorQuestionTitle = useFeatureIslandCategoryContext((state) => state.addErrorQuestionTitle);
		const removeErrorQuestionTitle = useFeatureIslandCategoryContext((state) => state.removeErrorQuestionTitle);

		const addEditedQuestionTitle = useFeatureIslandCategoryContext((state) => state.addEditedQuestionTitle);
		const removeEditedQuestionTitle = useFeatureIslandCategoryContext((state) => state.removeEditedQuestionTitle);

		useEffect(() => {
			if (isEdited) {
				addEditedQuestionTitle(title);
			} else {
				removeEditedQuestionTitle(title);
			}
		}, [isEdited, addEditedQuestionTitle, title, removeEditedQuestionTitle, categoryTitle]);

		useEffect(() => {
			if (hasError) {
				addErrorQuestionTitle(title);
			} else {
				removeErrorQuestionTitle(title);
			}
		}, [addErrorQuestionTitle, hasError, title, removeErrorQuestionTitle]);

		return (
			// タイトルと入力項目が縦並び
			<div className="flex flex-col gap-2" data-title={title}>
				{/* 編集ステータス（<Dot />）用の高さを確保している */}
				<div className="mt-3.5 flex flex-col gap-4">
					<div className="flex items-start">
						<div className="relative flex flex-wrap items-center gap-x-2 gap-y-1">
							{/* 編集ステータス（<Dot />） */}
							<div className="absolute -top-[14px]">
								<div className="flex items-center gap-x-2">
									{isEdited && <Dot />}
									{hasError && <Dot variant={"red"} />}
								</div>
							</div>

							{/* 設定項目のタイトル */}

							<QuestionTitle title={title} />
							{required && <Label text={"必須"} size={"sm"} variant={"required"} />}
							{/* 設定を補助するテキスト */}
							<EditGuideTooltip guide={guide} />
						</div>
					</div>
					<div className="ml-2">
						<QuestionItemsInnerWrapper>{inputChildren}</QuestionItemsInnerWrapper>
					</div>
				</div>
			</div>

			// タイトルと入力項目が横並び
			// <div className="flex flex-col gap-2">
			// 	<div>{required && <Label text={"必須"} size={"sm"} />}</div>

			// 	<div className="flex flex-col gap-4 lg:grid lg:grid-cols-12">
			// 		<div className="col-span-4 flex items-start">
			// 			<div className="flex flex-wrap items-center gap-x-2 gap-y-1">
			// 				<h5>{label}</h5>
			// 				<EditGuideTooltip guide={guide} />
			// 			</div>
			// 		</div>
			// 		<div className="col-span-8">{inputChildren}</div>
			// 	</div>
			// </div>
		);
	},
);

FeatureIslandCategoryQuestionForMain.displayName = "FeatureIslandCategoryQuestionForMain";
